function normalizeDuplicateRecommendationPriceRanges(scope) {
  scope.querySelectorAll(".fs-recommendation-product-price").forEach((priceEl) => {
    const text = priceEl.textContent.replace(/\s+/g, " ").trim();
    const match = text.match(/^(.+?)\s*[-–]\s*(.+)$/);

    if (!match) return;

    const firstPrice = match[1].trim();
    const secondPrice = match[2].trim();

    if (firstPrice === secondPrice) {
      priceEl.textContent = firstPrice;
    }
  });
}


function updateSwatches(colors, showMoreClick, element) {
  console.log({ colors, showMoreClick, element, msg: 'swatches' });
  const showMoreSwatch = element.querySelector(".show-more-swatches")
  if (!showMoreSwatch) return

  const totalColors = Array.isArray(colors)
    ? colors.length
    : Object.keys(colors || {}).length;

  let expanded = false;

  function updateButton() {
    const visibleSwatches = element.querySelectorAll(".color-swatch-container").length;
    const hiddenCount = Math.max(0, totalColors - visibleSwatches);
    const link = document.createElement('a')
    const url = element.querySelector(".color-swatch-container")?.dataset.altUrl;
    link.textContent = `+ ${hiddenCount}`
    link.classList.add('color-swatch-more')
    link.title = `View all ${totalColors} colors`
    if (url) {
      link.href = url;
    }

    showMoreSwatch.replaceWith(link)
  }

  updateButton();
}

function getProductData(products, productElement) {
  if (!products || !productElement) { return null }

  const productID = productElement.dataset.id || productElement.dataset.productId
  if (!productID) { return null }
  if (products[productID]) { return products[productID] }

  const list = Array.isArray(products) ? products : Object.values(products)
  return list.find((product) => String(product?.id) === String(productID)) || null
}

function upsellHooks() {

  window.FastRecommendationWidget.registerHook("serp-product-swatches", ({ colors, swatchClick, showMoreClick, element }) => {
    let curProductElement = element.closest('.fs-upsell-cross-sell-product');
    updateSwatches(colors, showMoreClick, element);
  });


  window.FastRecommendationWidget.registerHook("upsell-cross-sell-products", ({ element, products }) => {
    normalizeDuplicateRecommendationPriceRanges(element);
    window.fsProduct = Object.assign(window.fsProduct || {}, products)
    // FSHooks overwrites window.fsProduct on search renders; ajaxcart.js re-syncs cards from this.
    window.fsUpsellProducts = Object.assign(window.fsUpsellProducts || {}, products)

    for (const productElement of element.querySelectorAll(".fs-upsell-cross-sell-product")) {
      const data = getProductData(products, productElement);

      if (data?.vendor) {
        const productInfo = productElement.querySelector(".fs-recommendation-product-info");
        if (productInfo && !productElement.querySelector(".fs-upsell-vendor-name")) {
          const vendorDiv = document.createElement("div");
          vendorDiv.className = "fs-upsell-vendor-name";
          vendorDiv.textContent = data.vendor;
          productInfo.insertAdjacentElement("beforebegin", vendorDiv);
        }
      }

      if (typeof window.initAjaxcartUpsellAtc === 'function') {
        window.initAjaxcartUpsellAtc(productElement, data)
      }
    }
  });
}

if (window.FastRecommendationWidget) {
  console.log("FAST SIMON CODE 1");
  upsellHooks();
} else {
  window.addEventListener('fast-upsell-cross-sell-ready', function () {
    console.log("FAST SIMON CODE 2");
    upsellHooks();
  });
}